import React from 'react';
import './Select.css';

export default class Select extends React.Component {
	
	static defaultProps = {
		label: 'Username',
		value: 'volvo',
		options: [],
		callback: () => {}
	};
	
	renderOptions = () => {
		
		if (this.props.options.length > 0) {
			return this.props.options.map(option => (
				<option key={option.id } value={option.id}>{option.name}</option>
			))
		}
	};
	
	render = () => {
		return (
			<div>
				<div className="gfield gfield_genesis">
					{ (this.props.value === '') &&
						<label className="gfield_label" htmlFor="username">{this.props.label}</label>}
					<div className="ginput_container">
						<select className="gfield_select" value={this.props.value} onChange={(event) => {
							this.props.callback(event.target.value);
						}}>
							{this.renderOptions()}
						</select>
					</div>
				</div>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/Vacancies/Select.js